import {ReactNode} from "react";

import {Alert} from "@/components/alert/Alert.tsx";

interface FormWarningProps {
  warnings: ReactNode[];
  title?: string;
}

export const FormWarning = ({warnings, title}: FormWarningProps) => {
  if (!warnings || !warnings.length) {
    return null;
  }

  let warning;
  if (warnings.length > 1) {
    const warningItems = warnings.map((v, i) => <li key={`warn-${i}`}>{v}</li>);
    warning = <ul className="mb-1 list-noindent">{warningItems}</ul>;
  } else {
    warning = <p className="mb-1">{warnings[0]}</p>;
  }
  return (
    <Alert className={"mt-4"} variant={"maintenance"} size={"large"} header={title}>
      {warning}
    </Alert>
  );
};
